import React from 'react'

function RejectButton(props) {
  return <button className="btn btn-danger" data-toggle="modal" data-target="#reject-refunds-modal">
    Reject Refund
  </button>
}

export default RejectButton